import { Link } from "react-router-dom";

const sitemap = [
  {
    title: "网站导航",
    links: [
      { label: "首页", to: "/" },
      { label: "资讯中心", to: "/news" },
      { label: "作品展示", to: "/works" },
      { label: "关于张津瑜", to: "/about" },
      { label: "联系我们", to: "/contact" },
    ],
  },
  {
    title: "资讯分类",
    links: [
      { label: "最新动态", to: "/news?category=%E6%9C%80%E6%96%B0%E5%8A%A8%E6%80%81" },
      { label: "活动公告", to: "/news?category=%E6%B4%BB%E5%8A%A8%E5%85%AC%E5%91%8A" },
      { label: "行业观点", to: "/news?category=%E8%A1%8C%E4%B8%9A%E8%A7%82%E7%82%B9" },
      { label: "媒体访谈", to: "/news?category=%E5%AA%92%E4%BD%93%E8%AE%BF%E8%B0%88" },
    ],
  },
  {
    title: "作品类型",
    links: [
      { label: "视觉大片", to: "/works?type=%E8%A7%86%E8%A7%89%E5%A4%A7%E7%89%87" },
      { label: "品牌短片", to: "/works?type=%E5%93%81%E7%89%8C%E7%9F%AD%E7%89%87" },
      { label: "公益影像", to: "/works?type=%E5%85%AC%E7%9B%8A%E5%BD%B1%E5%83%8F" },
      { label: "时尚企划", to: "/works?type=%E6%97%B6%E5%B0%9A%E4%BC%81%E5%88%92" },
    ],
  },
];

const socials = [
  { icon: "ri-weibo-fill", label: "微博" },
  { icon: "ri-wechat-fill", label: "微信" },
  { icon: "ri-bilibili-fill", label: "哔哩哔哩" },
  { icon: "ri-youtube-fill", label: "视频号" },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 lg:px-10 lg:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 font-heading text-lg font-bold text-primary-900">
                津
              </span>
              <span className="font-heading text-lg font-bold tracking-wide text-background-50">
                张津瑜
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-300">
              个人品牌官方网站与资讯中心。以真诚的表达连接粉丝与合作伙伴，持续输出有价值的内容与作品。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {socials.map((s) => (
                <span
                  key={s.label}
                  title={s.label}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md bg-primary-800 text-background-200 transition-colors hover:bg-accent-500 hover:text-primary-900"
                >
                  <i className={`${s.icon} text-lg`} />
                </span>
              ))}
            </div>
          </div>

          {sitemap.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-sm font-semibold text-background-50">
                <a href={col.links[0].to} className="hover:text-accent-400">
                  {col.title}
                </a>
              </h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-300 transition-colors hover:text-accent-400"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-primary-700 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-400">
            © 2026 张津瑜个人品牌官方网站 · 内容仅供展示，部分数据为前端演示
          </p>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-background-400">
            <span className="cursor-pointer transition-colors hover:text-accent-400">网站声明</span>
            <span className="cursor-pointer transition-colors hover:text-accent-400">使用条款</span>
            <span className="cursor-pointer transition-colors hover:text-accent-400">版权声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}